export default "__VITE_ASSET__1221edfc__"